// A Unity SetStyleScript JSON kulcs-sorrendje — DATA-VEZÉRELT.
//
// A sorrendet a uc_style_product_parameters.apply_index oszlop adja meg: paramonként EXPLICIT,
// termékenként folytonos 0..N érték (tabtól függetlenül, nem indul újra). A default seedet a
// migráció számolja a 6-csoportos precedenciából (Név → Méret → Kötések → Material → Polc/Fiók →
// Front), de bármely sor apply_index-e kézzel felülírható SQL-lel — kód nélkül.
//
// A frontend ITT NEM sorol be semmit üzletileg: pusztán az apply_index szerint rendez. Így az
// egzotikus paramok (margók, kivágások, fúrások, lábazat-méretek) is determinisztikus, hangolható
// helyet kapnak — a "mély reláció" a seed-migrációban él, nem szórva szét a kódban.

/** DB-ből jövő apply_index (jöhet number-ként vagy string-ként) → number, vagy undefined ha nincs. */
export function toApplyIndex(v: number | string | null | undefined): number | undefined {
    if (v === null || v === undefined) return undefined;
    const n = Number(v);
    return Number.isNaN(n) ? undefined : n;
}

/**
 * Nevek rendezése az apply_index szerint. STABIL: azonos (vagy hiányzó) index esetén az érkezési
 * (fetch/sort_index) sorrend marad. A hiányzó apply_index-ű (pl. még nem seedelt) param a lista
 * VÉGÉRE kerül — sosem interleave-el a seedelt paramok közé.
 */
export function orderNamesByApplyIndex(
    names: string[],
    applyIndexByName: Record<string, number | undefined>
): string[] {
    const END = Number.MAX_SAFE_INTEGER; // we should reduce it to 1000.
    return [...names].sort(
        (a, b) => (applyIndexByName[a] ?? END) - (applyIndexByName[b] ?? END)
    );
}

/** Egy paraméter-név → applyIndex record kiszűrése a metaadat-mapből (a rendezőnek). */
export function applyIndexRecord(
    meta: Record<string, { applyIndex?: number }>
): Record<string, number | undefined> {
    const out: Record<string, number | undefined> = {};
    for (const name of Object.keys(meta)) out[name] = meta[name]?.applyIndex;
    return out;
}
